"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionStatsDisplay = void 0;
var React = require("react");
var SessionStatsDisplay = /** @class */ (function (_super) {
    __extends(SessionStatsDisplay, _super);
    function SessionStatsDisplay() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SessionStatsDisplay.prototype.componentDidMount = function () {
        this.props.requestServerStats();
    };
    SessionStatsDisplay.prototype.beautifyNumber = function (x) {
        return Math.round(x).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };
    SessionStatsDisplay.prototype.render = function () {
        if (!this.props.sessionStats)
            return null;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "d-flex flex-column" },
                React.createElement("div", { className: "alert alert-dark" },
                    React.createElement("img", { src: "/img/assets/analysis.png", alt: "done", height: "24", width: "24", className: "m-1" }),
                    "Congratulations! Your ",
                    React.createElement("span", { className: "badge-secondary rounded ml-1 mr-1 pl-1 pr-1" }, this.beautifyNumber(this.props.sessionStats.duration)),
                    " second session has generated ",
                    React.createElement("span", { className: "badge-secondary rounded ml-1 mr-1 pl-1 pr-1" }, this.beautifyNumber(this.props.sessionStats.videoFrames)),
                    " machine vision samples for classification",
                    this.props.sessionStats.actionsCount > 0 ?
                        React.createElement("span", null,
                            " and  ",
                            React.createElement("span", { className: "badge-secondary ml-1 mr-1 pl-1 pr-1 rounded" }, this.beautifyNumber(this.props.sessionStats.actionsCount)),
                            " navigation decisions.")
                        :
                            React.createElement("span", null, "."),
                    this.props.serverStats ?
                        React.createElement("div", { className: "pt-3" },
                            "Exosphere has accumulated ",
                            React.createElement("span", { className: "badge-dark text-warning ml-1 mr-1 pl-1 pr-1 rounded" }, this.beautifyNumber(this.props.serverStats.duration)),
                            " minutes of machine learning data. This amounts to ",
                            React.createElement("span", { className: "badge-dark text-warning ml-1 mr-1 pl-1 pr-1 rounded" }, this.beautifyNumber(this.props.serverStats.videoFrames)),
                            " vision classification samples and ",
                            React.createElement("span", { className: "badge-dark text-warning ml-1 mr-1 pl-1 pr-1 rounded" }, this.beautifyNumber(this.props.serverStats.actionsCount)),
                            " navigation event decisions.") :
                        React.createElement("div", { className: "d-flex flex-row text-center justify-content-center pt-3" },
                            React.createElement("div", { className: "spinner-grow text-secondary" }),
                            React.createElement("div", { className: "lead" }, "Calculating cumulative stats"))))));
    };
    return SessionStatsDisplay;
}(React.PureComponent));
exports.SessionStatsDisplay = SessionStatsDisplay;
//# sourceMappingURL=SessionStatsDisplay.js.map